import { render, staticRenderFns } from "./ursLoginPanel.vue?vue&type=template&id=7a70fcce&scoped=true"
import script from "./ursLoginPanel.vue?vue&type=script&lang=js"
export * from "./ursLoginPanel.vue?vue&type=script&lang=js"
import style0 from "./ursLoginPanel.vue?vue&type=style&index=0&id=7a70fcce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70fcce",
  null
  
)

export default component.exports